import React from "react";
import "react-spring-bottom-sheet/dist/style.css";
import { ReactComponent as CrossIcon } from "../../assets/icons/cross.svg";
import { BottomSheet } from "react-spring-bottom-sheet";
const ModalBottom = ({
  showModal,
  setShowModal,
  title,
  footer,
  children,
  defaultHeight,
  onClose,
  header,
}) => {
  return (
    <BottomSheet
      open={showModal}
      onDismiss={() => {
        setShowModal(false);
        onClose && onClose();
      }}
      header={
        !header ? (
          <>
            <div className="flex w-full items-center justify-between !border-none px-5 pb-4">
              <p className="text-lg font-semibold">{title}</p>
              <button
                onClick={() => {
                  setShowModal(false);
                  onClose && onClose();
                }}
                className="rounded-lg border border-monochrome-100 bg-white p-2 shadow-sm"
              >
                <CrossIcon />
              </button>
            </div>
            <div className="-mb-1 h-3 rounded-t-lg bg-white"></div>
          </>
        ) : (
          <>
            <div className="flex w-full items-center justify-between !border-none px-5 pb-4">
              {header}
              <button
                onClick={() => {
                  setShowModal(false);
                  onClose && onClose();
                }}
                className="rounded-lg border border-monochrome-100 bg-white p-2 shadow-sm"
              >
                <CrossIcon />
              </button>
            </div>
            <div className="-mb-1 h-3 rounded-t-lg bg-white"></div>
          </>
        )
      }
      snapPoints={({ minHeight, maxHeight }) => [
        minHeight,
        maxHeight * defaultHeight,
      ]}
      defaultSnap={({ snapPoints }) => snapPoints}
      footer={footer}
    >
      <>
        <div className="p-4">{children}</div>
      </>
    </BottomSheet>
  );
};

export default ModalBottom;
